import { render, staticRenderFns } from "./ot-organisation-calendar-details.vue?vue&type=template&id=2d517bc0&scoped=true&"
import script from "./ot-organisation-calendar-details.vue?vue&type=script&lang=ts&"
export * from "./ot-organisation-calendar-details.vue?vue&type=script&lang=ts&"
import style0 from "./ot-organisation-calendar-details.vue?vue&type=style&index=0&id=2d517bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d517bc0",
  null
  
)

export default component.exports